'use strict';

/* global yith_wcaf */

import { $ } from '../../src/globals.js';
import { initFields } from './modules/fields';
import YITH_WCAF_Profile_Fields_Table from './modules/yith-wcaf-profile-fields-table';
import YITH_WCAF_Gateways_Table from './modules/yith-wcaf-gateways-table';

class YITH_WCAF_Settings {
	constructor() {
		this.initFields();
		this.initAffiliateProfileFieldsTable();
		this.initGatewaysTable();

		$( document ).on(
			'click',
			'#yith-plugin-fw-float-save-button',
			function ( ev ) {
				const $form = $( '#plugin-fw-wc' ),
					valid = $form.triggerHandler( 'yith_wcaf_validate_fields' );

				if ( ! valid ) {
					ev.stopImmediatePropagation();

					return false;
				}
			}
		);
	}

	initFields() {
		initFields();
	}

	initAffiliateProfileFieldsTable() {
		const $context = $( '#yith_wcaf_profile_fields' );

		new YITH_WCAF_Profile_Fields_Table( $context );
	}

	initGatewaysTable() {
		const $context = $( '#yith_wcaf_gateways' ),
			$table = $( 'table.gateways', $context );

		if ( $table.length ) {
			new YITH_WCAF_Gateways_Table( $context );
		}
	}
}

$( () => new YITH_WCAF_Settings() );
